<div class="not-allowed-container">
  <p-card class="not-allowed-card">
      <div class="icon-container">
        <i class="pi pi-ban not-allowed-icon"></i>
      </div>

      <h1 class="title">{{ 'notAllowed.title' | translate }}</h1>

      <p class="description">
        {{ 'notAllowed.description' | translate }}
      </p>

      <p class="contact-info">
        {{ 'notAllowed.contactLineManager' | translate }}
      </p>
  </p-card>
</div>
